import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
} from "@mui/material";
import { ReactComponent as IconForward } from "../../assets/icons/iconforward.svg";
import { ReactComponent as IconDownload } from "../../assets/icons/icondownload.svg";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.svg";
 
const pages = [
  { name: "サービス", link: "/services" },
  { name: "特徴", link: "/features" },
  { name: "導入事例", link: "/achievements" },
  { name: "FAQ", link: "/faq" },
];
 
const NavbarLp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
 
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
 
  const isActive = (link) => decodeURIComponent(location.pathname) === link;
 
  return (
    <AppBar
      position={isScrolled ? "fixed" : "static"}
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        boxShadow: isScrolled ? "0 4px 10px -2px rgba(0, 0, 0, 0.2)" : "none",
        top: 0,
        width: "100%",
        transition: "all 0.5s ease",
        zIndex: 1200,
      }}
    >
      <Container maxWidth="false" style={{ width: "92%" }}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: { xs: 64, sm: 80 },
            justifyContent: "space-between",
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={Logo}
            alt="Logo"
            onClick={() => navigate("/")}
            sx={{
              width: 150,
              height: "auto",
              cursor: "pointer",
            }}
          />
 
          {/* Nav links + CTA buttons, single parent */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: "2em",
            }}
          >
            {pages.map((page) => (
              <Link
                key={page.name}
                to={page.link}
                style={{ textDecoration: "none" }}
              >
                <Button
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: isActive(page.link) ? "#FF6000" : "#000000",
                    "&:hover": {
                      color: "#FF6000",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {page.name}
                </Button>
              </Link>
            ))}
 
            <Button
              variant="contained"
              endIcon={<Box component={IconForward} sx={{ width: 16, height: 16 }} />}
              sx={{
                backgroundColor: "#FF6000",
                color: "#fff",
                borderRadius: "7px",
                textTransform: "none",
                boxShadow: "initial",
                px: 3,
                py: 1,
                fontSize: "15px",
                "&:hover": {
                  backgroundColor: "#e55500",
                },
              }}
            >
              無料相談
            </Button>
 
            <Button
              variant="outlined"
              endIcon={<Box component={IconDownload} sx={{ width: 16, height: 16 }} />}
              sx={{
                borderColor: "#000",
                color: "#000",
                borderRadius: "7px",
                textTransform: "none",
                px: 3,
                py: 1,
                fontSize: "15px",
                "&:hover": {
                  borderColor: "#000",
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              資料ダウンロード
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
 
export default NavbarLp;